[
  {"need":"hunger","band":"low","label":"Belle dey sing"},
  {"need":"hunger","band":"ok","label":"Belle dey calm"},
  {"need":"hunger","band":"high","label":"Belle full"},
  {"need":"energy","band":"low","label":"Body don tire"},
  {"need":"energy","band":"ok","label":"Body dey hold"},
  {"need":"energy","band":"high","label":"Fresh like new okpa"},
  {"need":"hygiene","band":"low","label":"Body dey shout for bucket"},
  {"need":"hygiene","band":"ok","label":"I dey clean small"},
  {"need":"hygiene","band":"high","label":"Smelling sharp sharp"}
]
